import ChartPanel from '/components/statistics/chart-panel'
import FilterBar from '/components/statistics/filter-bar'
import PageShell from '/components/statistics/page-shell'
import useClientStatistics from '/components/statistics/use-client-statistics'

const compactChartSetting = {
  yAxis: [{ label: 'count', width: 90 }]
}

const StatisticsScans = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics('scans')
  const scanSeries = (statistics.scanTrendSeries || []).map(item => ({
    dataKey: item.key,
    label: item.label,
    stack: 'action'
  }))

  return (
    <PageShell title="Statistics Scans" heading="Statistics - Scans">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          summaryItems={[
            { title: 'Total', value: statistics.extraTotals.scans },
            { title: 'Scan', value: statistics.extraTotals.scan },
            { title: 'Debit', value: statistics.extraTotals.debit },
            { title: 'Credit', value: statistics.extraTotals.credit },
            { title: 'Scanner', value: statistics.extraTotals.scanner },
            { title: 'Shopify', value: statistics.extraTotals.shopify }
          ]}
        />

        <ChartPanel
          title='Scan trends'
          description='Shows separate bars for scan, debit, and credit, stacked by source.'
          dataset={statistics.scanTrend}
          xAxis={{ scaleType: 'band', dataKey: 'bucket_action_label' }}
          series={scanSeries}
          loading={loading}
          height={440}
          yAxis={compactChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsScans
